module.exports = __webpack_public_path__ + "static/media/badge_icp.af6b078a.svg";